/**
 * ImageLightboxModal.jsx — Global in-app image viewer overlay.
 */

import { Show, onMount, onCleanup } from 'solid-js';
import { imageOverlay } from '../lib/imageOverlayStore.js';
import './ImageLightboxModal.css';

export default function ImageLightboxModal() {
  function handleKeyDown(e) {
    if (e.key === 'Escape' && imageOverlay.active()) {
      imageOverlay.close();
    }
  }

  onMount(() => {
    window.addEventListener('keydown', handleKeyDown);
  });

  onCleanup(() => {
    window.removeEventListener('keydown', handleKeyDown);
  });

  return (
    <Show when={imageOverlay.active()}>
      {(img) => (
        <div class="v2-img-lightbox" onClick={() => imageOverlay.close()}>
          <div class="v2-img-lightbox__backdrop" />
          <div class="v2-img-lightbox__container" onClick={(e) => e.stopPropagation()}>
            <div class="v2-img-lightbox__header">
              <span class="v2-img-lightbox__title">{img().caption || img().alt || 'Image Preview'}</span>
              <div class="v2-img-lightbox__actions">
                <a
                  href={img().url}
                  target="_blank"
                  rel="noopener noreferrer"
                  class="v2-img-lightbox__btn"
                  title="Open full size in new tab"
                >
                  ↗ Open
                </a>
                <button
                  class="v2-img-lightbox__btn v2-img-lightbox__btn--close"
                  onClick={() => imageOverlay.close()}
                  title="Close (Esc)"
                >
                  ✕
                </button>
              </div>
            </div>

            <div class="v2-img-lightbox__body">
              <img
                src={img().url}
                alt={img().alt || 'Full preview'}
                class="v2-img-lightbox__image"
              />
            </div>
          </div>
        </div>
      )}
    </Show>
  );
}
